<template>
  <div class="rightAll">
    <div class="rightAll-form">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item :label="$t('common.num')">
          <el-select
            v-model="formInline.selectCarType"
            style="width: 120px"
            :placeholder="$t('common.form.choseTip')"
            class="selectStyle"
          >
            <el-option
              v-for="item in optionsInput"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-input
            size="mini"
            v-model="formInline.selectCarValue"
            :placeholder="$t('common.searchTip')"
            style="width: 150px"
            class="inputStyle"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('SafeManagement.spotCheckDate')">
          <el-date-picker
            v-model="formInline.checkTime"
            type="daterange"
            style="width: 230px"
            size="mini"
            value-format="yyyy-MM-dd"
            range-separator
            :start-placeholder="$t('common.btn.choseDate')"
            end-placeholder
          ></el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('SafeManagement.spotCheckType')">
          <el-select
            v-model="formInline.spotCheckType"
            :placeholder="$t('common.form.choseTip')"
            filterable
            size="mini"
            style="width: 120px; margin-left: 5px"
          >
            <el-option
              v-for="item in typeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            size="mini"
            type="primary"
            @click="onSearch"
            class="btn-chaxun"
            >{{ $t("common.btn.search") }}</el-button
          >
          <el-button size="mini" @click="onClear" class="btn-del">{{
            $t("common.btn.cancel")
          }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="rightAll-btn">
      <el-button
        v-if="isPrimaryKey('CHECKREMIND_INSPECTION')"
        type="text"
        :disabled="selected.length != 1"
        @click="addCheck"
        >{{ $t("SafeManagement.btn.spotCheck") }}</el-button
      >
      <el-button
        v-if="isPrimaryKey('CHECKREMIND_VIEWREPORT')"
        type="text"
        :disabled="selected.length != 1"
        @click="viewReport"
        >{{ $t("SafeManagement.form.queryReport") }}</el-button
      >
      <el-button
        v-if="isPrimaryKey('CHECKREMIND_DOWN')"
        type="text"
        @click="down"
        >{{ $t("common.btn.download") }}</el-button
      >
    </div>
    <i-table
      :list="list"
      :height="height"
      ref="carTable"
      @handleSelectionChange="handleSelectionChange"
      :options="option"
      :columns="columns"
      :operates="operates"
    ></i-table>
    <IPagination ref="page" @PageFun="changeSize"></IPagination>
    <el-dialog
      width="70%"
      :before-close="closeDia"
      class="addDialong"
      :title="diaTitle"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <!-- <el-dialog
        width="30%"
        title=""
        :visible.sync="innerVisible"
        append-to-body
      >
        <div>{{$t('SafeManagement.form.ThereAreAbnormalItemsInTheProjectYouSubmittedWhetherToSubmit')}}</div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="innerVisible = false"
            >{{$t('common.btn.cancel')}}</el-button
                >
          <el-button size="small" type="primary" @click="submitForm('form')"
            >{{$t('common.btn.confirm')}}</el-button
          >
        </div>
      </el-dialog> -->
      <el-form :rules="rules" ref="form" :model="form">
        <div style="display: flex">
          <div style="width: 50%; height: 400px">
            <el-form-item
              prop="spotCheckDate"
              :label="$t('SafeManagement.resubmissions') + ':'"
            >
              <div style="width: 100%; display: flex">
                <el-checkbox
                  v-model="form.whetherSupplement"
                  style="padding-right: 20px"
                  >{{ $t("SafeManagement.resubmissions") }}</el-checkbox
                >
                <el-date-picker
                  value-format="yyyy-MM-dd"
                  type="date"
                  :placeholder="$t('common.btn.choseDate')"
                  v-model="form.spotCheckDate"
                  :picker-options="pickerOptions"
                  class="textareaStyle"
                ></el-date-picker>
              </div>
            </el-form-item>
            <div
              style="
                color: #333;
                border-bottom: 1px solid #c6cad2;
                margin-bottom: 10px;
                line-height: 30px;
              "
            >
              {{ $t("SafeManagement.checkName") }}
            </div>
            <el-scrollbar>
              <el-form-item
                prop="carId"
                :label="item.checkName"
                :label-width="formLabelWidth"
                v-for="(item, index) in form.radioList"
                :key="index"
              >
                <el-radio-group v-model="item.isWarning" @change="changeRadio" class="radioStyle">
                  <el-radio :label="0">{{ $t("common.normal") }}</el-radio>
                  <el-radio :label="1">{{ $t("common.abnormal") }}</el-radio>
                </el-radio-group>
                <span style="color: red; padding-left: 20px">{{
                  item.checkReference
                }}</span>
              </el-form-item>
            </el-scrollbar>
          </div>
          <div style="width: 50%; margin-left: 20px">
            <el-form-item
              prop="carUseState"
              :label="$t('SafeManagement.carUseState') + ':'"
            >
              <el-select
                v-model="form.carUseState"
                :placeholder="$t('SafeManagement.form.carUseState')"
                filterable
                class="textareaStyle"
              >
                <el-option
                  v-for="item in UseStateList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="carMileage" label="点检人">
              <div v-if="isShow">
                <el-button @click="btnSignature">签名</el-button>
              </div>
              <div v-else>
                <img
                  :src="form.checkFile"
                  @click="previewImage"
                  style="height: 100px"
                />
              </div>
            </el-form-item>
            <el-form-item
              prop="carMileage"
              :label="$t('SafeManagement.carMileage')"
            >
              <el-input
                size="small"
                v-model="form.carMileage"
                autocomplete="off"
                class="textareaStyle"
              ></el-input>
            </el-form-item>
            <el-form-item
              v-if="isDisplay"
              prop="phone"
              :label="$t('DriverManagement.phone')"
            >
              <el-input
                size="small"
                v-model="form.phone"
                autocomplete="off"
                class="textareaStyle"
              ></el-input>
            </el-form-item>
            <el-form-item prop="remarks" :label="$t('common.remark')">
              <el-input
                size="small"
                v-model="form.remarks"
                autocomplete="off"
                type="textarea"
                :rows="4"
                class="textareaStyle"
              ></el-input>
            </el-form-item>
            <el-form-item
              prop="filePath"
              :label="$t('common.btn.uploadPicture')"
              style="margin-top: 20px"
              class="imgStyle"
            >
              <el-upload
                class="avatar-uploader"
                :action="processImg"
                list-type="picture-card"
                :file-list="FileList"
                :limit="4"
                :on-success="handleAvatarSuccess"
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog
                :visible.sync="dialogVisible"
                append-to-body
                class="imgForm"
              >
                <img width="100%" :src="imageUrl" alt="" class="avatar" />
              </el-dialog>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancle('form')">{{
          $t("common.btn.cancel")
        }}</el-button>
        <el-button size="small" type="primary" @click="submitForm('form',0)">{{
          $t("common.btn.confirm")
        }}</el-button>
        <el-button v-if="isDisplay" style="width: 140px;" size="small" type="primary" @click="submitForm('form',1)">{{
          $t("SafeManagement.btn.determineGenerateRepairOrder")
        }}</el-button>
      </div>
    </el-dialog>
    <el-dialog
      width="70%"
      class="tableDialong"
      title="签名"
      :visible.sync="dialogSignatureFormVisible"
      :close-on-click-modal="false"
    >
      <div class="allDialong">
        <signature ref="signature" @saveAsImage="saveAsImage"></signature>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancleSignature('signature')">{{
          $t("common.btn.cancel")
        }}</el-button>
        <el-button size="small" type="primary" @click="submitSignatureForm('signature')">{{
          $t("common.btn.confirm")
        }}</el-button>
      </div>
    </el-dialog>
    <el-dialog
      width="1200px"
      class="tableDialong"
      :title="$t('SafeManagement.form.queryReport')"
      :visible.sync="dialogDetailsFormVisible"
      :close-on-click-modal="false"
    >
      <div class="allDialong">
        <DriverSwiping ref="carIdSwiping"></DriverSwiping>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CheckRemind from "./CheckRemind.js";
export default CheckRemind;
</script>

<style lang="less" scoped>
@import "../../../../assets/styles/Style.less";
</style>
